export default __webpack_public_path__ + "static/media/prev-airlockz.116028f4.jpg";